import React from 'react';
import { Button } from 'primereact/button';
import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';
import { downloadCaseBulkFiles } from 'services/fileManager/fileManagerServices';
import { useNavbarContext } from 'context/NavbarContext';
import { useToast } from 'context/ToastContext';
import { toastConstant } from 'constants/toastmessage';
import { uuidv4 } from 'common/uuidGenerator';

function DownloadCaseButton() {
  const { caseDetails } = useFileManagerContext();
  const { addFolderDownload } = useNavbarContext();
  const { addToast } = useToast();

  const handleDownloadCase = async () => {
    const caseId = caseDetails?.case_id;
    const caseName = caseDetails?.case_description?.case_name ?? caseDetails?.case_name ?? 'Case';

    const downloadId = uuidv4();

    try {
      addFolderDownload({
        id: downloadId,
        folderName: caseName,
        caseId,
        status: 'In Progress',
        progress: 0,
        zipFile: null,
        error: null,
        type: 'download_case',
        case_name: caseName,
        is_lead: caseDetails?.is_lead,
      });

      await downloadCaseBulkFiles({ case_id: caseId }, 'download_case');
    } catch (error) {
      console.log('Error downloading case:', error);
      addFolderDownload({
        id: downloadId,
        folderName: caseName,
        caseId,
        status: 'failed',
        error: error.message || 'Failed to download case',
        type: 'download_case',
      });
      addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, 'Failed to download case');
    }
  };

  return <Button label="Download Case" className="p-button-primary outline text-nowrap" onClick={handleDownloadCase} />;
}

export default DownloadCaseButton;
